"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RocheMenu = void 0;

var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));

var _core = require("../core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var RocheMenu = _Menu["default"];
exports.RocheMenu = RocheMenu;
RocheMenu.displayName = (0, _core.rochePrefix)('Menu');
RocheMenu.defaultProps = {
  keepMounted: true,
  getContentAnchorEl: null,
  anchorOrigin: {
    horizontal: 'left',
    vertical: 'bottom'
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  }
};
var _default = RocheMenu;
exports["default"] = _default;